export enum MenuItems {
  GO_TO_ITEM = 'Go to Item',
  MARK_AS_COMPLETE = 'Mark as Complete',
  CANCEL = 'Cancel',
}
